/* eslint-disable no-restricted-globals, import/no-extraneous-dependencies */
import React, { memo } from "react";
import RichText from "@qlik/qlik/src/components/RichText";
import { renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";

/**
 * CounterCard component
 * @param {Object} props - The props for the CounterCard component
 * @param {Object} props.card - The card object
 * @param {string} props.className - The class name for the CounterCard component
 * @returns {JSX.Element} - Rendered CounterCard component
 */
const CounterCard = ({ card, className = "" }) => {
    const { title, subtitle, description, body } = card || {};
    const descriptionText = description?.description ?? null;
    const bodyContent = body?.raw ?? null;

    return (
        <div className={`border-l border-black border-opacity-10 px-5 lg:px-7.5 pb-5 ${className}`}>
            <p
                style={{
                    wordBreak: "break-word",
                    hyphens: "auto",
                }}
                className="text-ocean text-4xl md:text-4xl lg:text-6xl font-semibold leading-tight tracking-tight10 py-1 mb-1.5 lg:mb-5 relative before:content-empty before:block before:absolute before:-left-5.25 lg:before:-left-[31px] before:h-9 before:top-1 lg:before:h-full lg:before:top-0 before:w-0.75 before:bg-ocean"
            >
                {title}
            </p>
            {/* eslint-disable-next-line react/no-danger */}
            {subtitle && (
                <h3 className="title-5" dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(subtitle) }} />
            )}
            {descriptionText && <p className="mt-5">{descriptionText}</p>}
            {bodyContent && <RichText data={card} />}
        </div>
    );
};

// Export the memoized version of CounterCard to prevent unnecessary re-renders
export default memo(CounterCard);
